import getPresetPage from 'src/model/preset-pages';
import CustomButtonActions from './custom-actions';

// eslint-disable-next-line import/prefer-default-export
export class Pages {
    constructor (app) {
        this.app = app;
        this.history = [];
        this.page = undefined;
        window.onpopstate = (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (this.page && this.page.to === 'quiz-result') {
                this.back({ to: 'tasks' });
                return false;
            }
            this.back();
            return false;
        };
    }

    internalPush (payload) {
        if (payload.uuid === '#back' && this.history.length > 1) {
            this.history.pop();
            const h = this.history.pop();
            h.isBack = true;
            this.internalPush(h);
            return;
        }
        if (payload.uuid === '#back') { return; }
        payload.type = payload.type ?? 'Page';
        this.history.push(payload);
        this.show(payload);
    }

    popCurrentPage () {
        this.history.pop();
    }

    show (page) {
        document.title = page.title || '1Т Курс';
        this.app.$store.commit('pages/setPage', { ...page });
        this.page = page;
        if (page.to !== 'login' && page.to !== 'bio') {
            sessionStorage.setItem('page', JSON.stringify(page));
        } else {
            sessionStorage.removeItem('page');
        }
        const id = new Date().getTime();
        // window.history.pushState({ page: id }, '', `#${this.app.$route.fullPath}`);
        window.history.pushState({ page: id }, '', `${this.app.$route.fullPath}`);
        // window.history.pushState({ page: id }, '', '/');
    }

    push (params) {
        const {
            to, href, title,
        } = params;
        if (to === '#href') {
            if (href) {
                window.open(href, '_blank');
                return;
            }
        }
        if (to) {
            const presetPage = getPresetPage(to);
            if (presetPage) {
                this.internalPush({ type: presetPage.type, title, ...params });
            } else {
                if (this.checkCustomAction(params)) {
                    return;
                }
                this.internalPush({
                    uuid: to, type: 'Page', title,
                });
            }
        }
    }

    back (payload) {
        if (payload) {
            const { to } = payload;
            const { history } = this;
            for (let i = 0; i < history.length; i += 1) {
                const h = history[i];
                if (h.to === to) {
                    this.history = history.slice(0, i + 1);
                    this.show(h);
                    return;
                }
            }
            return;
        }
        this.internalPush({ uuid: '#back' });
    }

    backToRoot () {
        const { history } = this;
        const h = history[0];
        this.history = history.slice(0, 1);
        this.show(h);
    }

    // eslint-disable-next-line class-methods-use-this
    checkCustomAction (params) {
        if (params.to === 'create_cert3') {
            const ca = new CustomButtonActions(this.app);
            ca.createCertCommon(params);
            /*
            console.log(params);
            if (params.cert_type === 'Сертификат 1') {
                ca.createCert1();
            }
            if (params.cert_type === 'Сертификат 2') {
                ca.createCert3();
            }
             */
            return true;
        }

        // Страница курса
        if (params.to === 'course_page') {
            // Если курс уже начат - то показывать страницу выбора заданий
            // Если курс завершен - то страницу завершения курса
            if (!this.app.$store.state.pages.user) {
                return true;
            }
            this.push({ to: 'course', title: params.label, course_id: params.course_id });
            /*
            const userId = this.app.$store.state.pages.user.id;
            this.app.$db.tasks.isCourseActive(params.course_id, userId).then((isActive) => {
                if (!isActive) {
                    this.push({ to: 'course', title: params.label, course_id: params.course_id });
                } else {
                    this.push({ to: 'tasks', title: params.label, course_id: params.course_id });
                }
            });
             */
            return true;
        }

        // Страница купленных курсов пользователя
        if (params.to === 'user_courses') {
            if (!this.app.$store.state.pages.user) {
                return true;
            }
            this.push({ to: 'my-courses' });
            return true;
        }

        // Страница информации о подписке
        if (params.to === 'subscription_page') {
            if (!this.app.$store.state.pages.user) {
                return true;
            }
            this.push({ to: 'subscription_page', subscription_id: params.subscription_id });
            return true;
        }

        return false;
    }
}
